import React from 'react';
import clsx from 'clsx';
import { makeStyles, Box, Fade } from '@material-ui/core';
import { headerHeight, mobileHeaderHeight, footerHeight } from '../theme';

import Loader from './Common/Loader';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  contentMargin: {
    marginLeft: 0,
    marginTop: headerHeight,
    marginBottom: footerHeight,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: mobileHeaderHeight,
    },
    padding: 0,
  },
  fetchingContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.65)',
    zIndex: 2,
  },
  fetchingLoader: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1302,
  },
  hidden: {
    visibility: 'hidden',
  },
}));

const Body = ({ loading = false, fetching = false, children }) => {
  const classes = useStyles();
  return (
    <>
      <Box height="100%" py={0} px={0} className={clsx(classes.root, [classes.contentMargin])}>
        {loading && <Loader />}
        <Fade in={fetching}>
          <div className={classes.fetchingContainer} />
        </Fade>
        <div className={clsx({ [classes.hidden]: loading })}>{children}</div>
      </Box>
      {fetching && (
        <div className={classes.fetchingLoader}>
          <Loader />
        </div>
      )}
    </>
  );
};

export default Body;
